<template lang="">
  <AccountLayout :loading="0" :isError=true>
    <v-container id="login">
      <v-row id="login-box" class="d-flex justify-center">
        <v-col
          class="pl-0"
          cols="12"
          sm="auto"
          md="auto"
          style="display:flex; z-index: 1; justify-center"
        >
          <div id="half-border">
            <v-img
              :src="require('@/assets/Group 92915.svg')"
              contain
              width="341"
              height="372"
              style="
                position: absolute;
                z-index: 1;
                margin-top: 4rem;
                margin-left: -10rem;
              "
            />
          </div>
          <v-card
            max-width="540"
            height="544px"
            style="border-radius: 0px 30px 30px 0px"
            elevation="0"
          >
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row class="mx-6">
                  <v-col cols="12" sm="12" md="12" class="text-center">
                    <div
                      class="mt-7 prompt-title-500"
                      style="color: #255d98; font-weight: 400"
                    >
                      {{ $t("message.loginPage.changePassword") }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <div class="pa-1 form-label">
                      {{ $t("message.loginPage.createPassword") }} <strong>*</strong>
                    </div>
                    <v-text-field
                      dense
                      outlined
                      hide-details="auto"
                      v-bind:placeholder="$t('message.loginPage.morePassword')"
                      v-model="password"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="passwordRules"
                      :type="showPass ? 'text' : 'password'"
                      @click:append="showPass = !showPass"
                      required
                    >
                      <template #message="{ message }">
                          {{ $t(message) }}
                        </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <div class="pa-1 form-label">
                      {{ $t("message.loginPage.confirmPassword") }} <strong>*</strong>
                    </div>
                    <v-text-field
                      dense
                      outlined
                      hide-details="auto"
                      v-bind:placeholder="$t('message.loginPage.confirmPassword')"
                      v-model="confirmPassword"
                      :append-icon="showConfirmPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[
                          (v) =>
                            (!!v && v) === this.password || 'message.loginPage.invalidPassword',
                        ]"
                      :type="showConfirmPass ? 'text' : 'password'"
                      @click:append="showConfirmPass = !showConfirmPass"
                      required
                    >
                      <template #message="{ message }">
                        {{ $t(message) }}
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    class="d-flex justify-center"
                  >
                    <v-btn
                      class="prompt-24"
                      :disabled="!checkFill"
                      :color="checkFill ? '#FF9800' : '#AFADB1'"
                      @click="validate"
                      rounded
                      height="40"
                      width="300"
                      style="
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 24px;
                        letter-spacing: 0.05rem;
                        color: #ffffff;
                      "
                    >
                      {{ $t("message.loginPage.confirm") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" persistent max-width="450">
        <v-card style="border-radius: 8px">
          <v-card-text>
            <v-col md="12" class="pt-5 d-flex justify-center">
              <v-spacer></v-spacer>
            </v-col>
            <v-col md="12" class="d-flex justify-center">
              <v-img
                :src="require('@/assets/right.svg')"
                contain
                width="40"
                height="40"
              />
            </v-col>
            <v-col
              md="12"
              class="my-1 d-flex justify-center"
              style="padding: 0 5rem"
            >
              <div class="prompt-title-500">{{ $t("message.loginPage.successChange") }}</div>
            </v-col>
            <v-col md="12" class="my-1 d-flex justify-center">
              <div class="form-label-400">{{ $t("message.loginPage.passwordChange") }}</div>
            </v-col>
            <v-card-actions>
              <v-col md="12" class="mb-1">
                <v-btn
                  class="prompt-24"
                  color="#FF9800"
                  block
                  rounded
                  dark
                  @click="dialog = false"
                  to="/login"
                  large
                  >{{ $t("message.loginPage.login") }}</v-btn
                >
              </v-col>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-dialog>
      <div id="orange-tab"></div>
    </v-container>
  </AccountLayout>
</template>
<script>
import AccountLayout from "@/components/common/AccountLayout";
export default {
    name: "ChangePasswordComp",
    components: { AccountLayout },
    data: () => ({
        dialog: false,
        valid: true,
        password: "",
        passwordRules: [
            (v) => (v || "").length > 8 || "message.loginPage.morePassword",
            (v) => !!v || "message.loginPage.morePassword",
        ],
        confirmPassword: "",
        showPass: false,
        showConfirmPass: false,
        success: false,
        checkSubmit: false,
        token: "",
        loading: 0,
        isError:true
    }),
    computed: {
        checkFill() {
            const checkNull = this.password != "" && this.confirmPassword != "";
            return this.valid && checkNull;
        },
    },
    methods: {
        async validate() {
            const valid = this.$refs.form.validate();
            if (valid) {
                try {
                    this.checkSubmit = true;
                    const body = {
                        newPassword: this.password,
                    };
                    const { data } = await services.getValidateChangePassword(
                        this.token
                    );
                    if (data.status == "ok") {
                        const res = await services.postChangePassword(
                            body,
                            this.token
                        );
                        if (res.status == 200) {
                            this.success = true;
                            this.dialog = true;
                        } else {
                            this.success = false;
                        }
                    } else {
                        router.push({
                            path: `/password_expired`,
                        });
                    }
                } catch (err) {
                    console.log(err);
                }
            }
        },
        getInitData() {
            this.token = this.$route.params.token;
        },
    },
    mounted() {
        this.getInitData();
    },
};

import * as services from "../../services";
import router from "@/router";
</script>
